import { FileUpload } from "@mui/icons-material";
import React, { useRef } from "react";
import "./Upload.css";
import { useCommentData } from "./CommentDataContext";

const Upload = () => {
  const { setCommentDetails, activeCell } = useCommentData();
  const fileInputRef = useRef(null);
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  // update uplaoded JSON data to scene
  function handleUploadJSON(e) {
    const file = e.target.files[0];
    if (!file) return;

    const fileName = file.name;
    const fileExtension = fileName.split(".").pop().toLowerCase();

    //  Only .cf allowed
    if (fileExtension !== "cf") {
      alert("Only .cf files are allowed!");
      e.target.value = "";
      return;
    }
    if (activeCell === null) {
      alert("Please select a cell before uploading a file.");
      e.target.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const importedData = JSON.parse(event.target.result);

        if (
          importedData.bug &&
          importedData.query &&
          importedData.improvement
        ) {
          // File name no longer needs to match the cell name. Instead, the
          // cell identity travels inside the JSON itself as "topCell"
          // (added at download time). We match against that field so
          // renaming the .cf file has no effect on upload. Files without
          // a topCell field (old exports) are no longer accepted.
          if (!importedData.topCell) {
            alert(
              "This file is missing cell information (topCell) and cannot be uploaded. Please re-download the file."
            );
            e.target.value = "";
            return;
          }
          if (importedData.topCell !== activeCell) {
            alert(
              `This file belongs to cell "${importedData.topCell}". Please select that cell before uploading.`
            );
            e.target.value = "";
            return;
          }

          setCommentDetails(null);
          const updateBool =
            window.canvasEngine.FeatureRenderer.uploadJSON(importedData);

          if (updateBool) {
            setCommentDetails(importedData);
            alert("File uploaded successfully");
          }
        } else {
          alert("Invalid .cf file structure!");
        }
      } catch (err) {
        console.error("Upload error:", err);
        alert("Invalid or corrupted .cf file");
      }
    };

    reader.readAsText(file);
  }
  
  return (
    <button className="upload-button" onClick={triggerFileInput}>
      <FileUpload className="upload-icon" />
      <input
        type="file"
        accept=".cf"
        onChange={handleUploadJSON}
        className="upload-input"
        ref={fileInputRef}
      />
    </button>
  );
};

export default Upload;
